import React, { Component } from 'react';

class ShowAllButton extends Component {
  render() {
    if (!this.props.show) { return null };

    const text = '全てのプランを見る';

    return (
      <div
        className="ShowAllButtonContainer"
      >
        <div
          className="BoxShadow ShowAllButton"
          onClick={this.props.onClick}
        >
          {text}
        </div>
      </div>
    );
  }
};


export default ShowAllButton;
